import React from 'react';
import { connect } from 'react-redux';

import { Ad } from '@spp/ad-components';

import textAdConfig from '../../ads/config';

// eslint-disable-next-line react/prop-types
const TextAd = ({ device, variants, ...rest }) => {
    const format = variants[0].invCode.split(/_(.+)/)[1];
    const platform = device.indexOf('mobile') > -1 ? 'mobile' : 'desktop';

    if (textAdConfig[platform].includes(format)) {
        return <Ad variants={variants} subtype="text-ad" {...rest} />;
    }

    return null;
};

const enhance = connect((state) => ({
    device: state.device,
}));

export default enhance(TextAd);



/** WEBPACK FOOTER **
 ** ./src/local-components/article/TextAd.js
 **/